/* To make a Bootstrap 5 accordion item open (toggle its collapse) when an internal hash link is clicked, you can use the following JavaScript. This code listens for hash changes (or loads with a hash in the URL) and opens the corresponding accordion item if its ID matches. 
*/

document.addEventListener("DOMContentLoaded", function () {
  function openAccordionFromHash() {
    const hash = window.location.hash;
    if (!hash) return;

    const targetItem = document.querySelector(hash);
    if (!targetItem) return;

    const collapse = targetItem.querySelector(".accordion-collapse");
    if (!collapse) return;

    // Close all other open accordion items in the same parent
    const parentAccordion = collapse.closest(".accordion");
    if (parentAccordion) {
      parentAccordion.querySelectorAll(".accordion-collapse.show").forEach(openItem => {
        if (openItem !== collapse) {
          bootstrap.Collapse.getOrCreateInstance(openItem).hide();
        }
      });
    }

    // Force open the target item
    bootstrap.Collapse.getOrCreateInstance(collapse).show();
  }

  // Open on page load
  openAccordionFromHash();

  // Open on internal hash link click
  document.querySelectorAll("a[href^='#']").forEach(link => {
    link.addEventListener("click", function (e) {
      // Wait for the hash to update
      setTimeout(openAccordionFromHash, 50);
    });
  });
});